<template>
	<div class="card overflow-hidden">
		<div class="card-header position-relative p-0 image-square text-center" :class="{ [$style.expired]: isExpired }">
			<div :class="$style.order">
				<a-tooltip placement="top">
					<template #title>
						<span>Orden</span>
					</template>

					<a-tag color="#108ee9">
						{{ data.order }}
					</a-tag>
				</a-tooltip>

				<a-tooltip placement="top">
					<template #title>
						<span>Posición</span>
					</template>

					<a-tag>
						{{ data.position }}
					</a-tag>
				</a-tooltip>
			</div>

			<div :class="$style.actions">
				<slot name="actions" :data="data">
					<a-tooltip placement="left">
						<template #title>
							<span>Eliminar banner</span>
						</template>
						<a-popconfirm title="¿Estás seguro que quires eliminar este banner?" ok-text="Borrar" cancel-text="Cancelar" @confirm="deleteBanner(data.id)">
							<a-button class="mr-2" shape="circle" size="large" type="danger">
								<fa-icon :icon="['far', 'trash']" />
							</a-button>
						</a-popconfirm>
					</a-tooltip>

					<a-tooltip placement="top">
						<template #title>
							<span>Editar banner</span>
						</template>

						<a-button class="mr-2" shape="circle" size="large" @click="setParams()">
							<fa-icon :icon="['far', 'pencil']" />
						</a-button>
					</a-tooltip>

					<a-tooltip v-if="data.banner_url" placement="top">
						<template #title>
							<span>Ir al banner</span>
						</template>
						<a-button shape="circle" size="large" @click="goTo">
							<a-icon type="link" />
						</a-button>
					</a-tooltip>
				</slot>
			</div>

			<img class="img-fluid m-0 height-350" :src="images().adaptative(data.image_url_horizontal || data.image_url, 400)" :alt="data.name">
		</div>

		<div class="card-body p-3">
			<div class="font-size-24 font-weight-bold text-dark">
				{{ data.name }}
			</div>
		</div>

		<div v-if="data.created_at || data.finished_at" class="card-footer d-flex flex-row py-1 px-3 align-items-center">
			<a-tooltip v-if="data.created_at" placement="top">
				<template #title>
					<span>{{ $moment(data.created_at).format('LLL') }}</span>
				</template>
				<b v-if="$moment().diff(data.created_at) > 0" class="text-uppercase text-muted mr-auto">
					{{ $moment(data.created_at).fromNow() }}
				</b>
				<b v-else class="text-uppercase text-danger mr-auto">
					<fa-icon :icon="['far', 'alarm-clock']" class="mr-2 animated pulse delay-1s infinite" />
					{{ $moment(data.created_at).fromNow() }}
				</b>
			</a-tooltip>

			<a-tooltip v-if="data.finished_at" placement="top">
				<template #title>
					<span v-if="isExpired">Caduca</span>
					<span v-else>Caducó</span>
					el
					<span>{{ $moment(data.finished_at).format('LLL') }}</span>
				</template>

				<b v-if="isExpired" class="text-uppercase text-muted">
					{{ $moment(data.finished_at).fromNow() }}
				</b>

				<b v-else class="text-uppercase text-danger">
					<fa-icon :icon="['fas', 'calendar-exclamation']" class="mr-2 animated pulse delay-1s infinite" />
					{{ $moment(data.finished_at).fromNow() }}
				</b>
			</a-tooltip>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BannerCard',
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	emits: ['set-params', 'delete'],
	computed: {
		isExpired() {
			return this.data.finished_at && this.$moment().diff(this.data.finished_at) > 0;
		},
	},
	methods: {
		goTo() {
			window.open(this.data.banner_url, '_blank');
		},
		setParams() {
			this.$emit('set-params');
		},
		deleteBanner(id) {
			this.$emit('delete', id);
		},
	},
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
